import "../../App/App.css";
const Login = () => {
  return (
    <div>
      <h1 className="login">Log In</h1>
    </div>
  );
};
export default Login;
